import { useMemo, type ChangeEvent } from 'react'

import { useSellers } from '@/common/entities/sellers'
import { Select, SelectOption } from '@/common/ui/Form/Select'

type CompanyStatsSellerSelectProps = {
    orgId: string
    value: string
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void
}

export const CompanyStatsSellerSelect = ({ orgId, value, onChange }: CompanyStatsSellerSelectProps) => {
    const { data: sellersPage } = useSellers(orgId)

    const sellerFilterOptions = useMemo(
        () => [
            { value: '', label: 'Все продавцы' },
            ...(sellersPage?.items ?? []).map(seller => ({
                value: seller.id,
                label: seller.name ?? seller.id,
            })),
        ],
        [sellersPage]
    )

    return (
        <Select value={value} onChange={onChange} placeholder='Все продавцы' aria-label='Фильтр по продавцу' size='lg'>
            {sellerFilterOptions.map(option => (
                <SelectOption key={option.value || 'all'} value={option.value}>
                    {option.label}
                </SelectOption>
            ))}
        </Select>
    )
}
